(function() {
    window.initIFrame = function (iframeId) {
        window.scrollIFrameParent = true;
        const iframeEle = document.getElementById(iframeId);
        const iframeDoc = iframeEle.contentDocument;
        const iframeBody = iframeEle.contentWindow.document.body;

        // Handle wheel events to support scrolling inside IFrame
        // Swipe events (touch devices) are converted into wheel events
        // using HammerJS
        let wheelTicking = false;
        const wheelHandler = (event, isSwipe = false) => {
            if (!wheelTicking) {
                window.requestAnimationFrame(() => {
                    if (window.scrollIFrameParent) {
                        isSwipe
                            ? window.scrollBy({
                                left: event.deltaX,
                                top: event.deltaY * -1,
                                behavior: 'smooth',
                            }): window.scrollBy(event.deltaX, event.deltaY);
                    }
                    wheelTicking = false;
                });
                wheelTicking = true;
            }
        }

        // Touch device support
        // When swiped inside IFrame, parent scrolls.
        // This is needed to show footer contents of the page when an iframe is embedded in a page
        const hm = new Hammer.Manager(iframeBody, {
            recognizers: [
                [Hammer.Swipe,{ direction: Hammer.DIRECTION_VERTICAL }],
            ]
        });
        hm.on('swipe', (event) => {
            wheelHandler(event, true);
        });

        // Mouse/touchpad support
        // When scrolled inside IFrame, parent scrolls.
        // This is needed to show footer contents of the page when an iframe is embedded in a page
        iframeDoc.addEventListener('wheel', (event) => {
            wheelHandler(event);
        });

        // Calculate the height of of the document (including non-visible content)
        let pageHeight = 0;
        function calcPageHeight() {
            function findHighestNode(nodesList) {
                for (let i = nodesList.length - 1; i >= 0; i--) {
                    if (nodesList[i].scrollHeight && nodesList[i].clientHeight) {
                        const elHeight = Math.max(nodesList[i].scrollHeight, nodesList[i].clientHeight);
                        pageHeight = Math.max(elHeight, pageHeight);
                    }
                    if (nodesList[i].childNodes.length) findHighestNode(nodesList[i].childNodes);
                }
            }

            findHighestNode(document.documentElement.childNodes);
            return (pageHeight) + 'px';
        }
        return calcPageHeight();
    };
})();
